import React, { Fragment, useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';

import Tooltip from 'components/Tooltip';
import ChangeNameModal from './ChangeNameModal';
import { IAppState } from 'types/app';

interface Props {
  name: string,
}

const tooltipData = {
  name: 'Change your name!',
  description: 'You need at least 15 Fate to do this',
};

function Name({ name }:Props ) {
  const ref = useRef<HTMLSpanElement>(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tooltipActive, setTooltipActive] = useState(false);

  const handleClick = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleRequestClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleMouseOver = useCallback(() => {
    setTooltipActive(true);
  }, []);

  const handleMouseOut = useCallback(() => {
    setTooltipActive(false);
  }, []);

  return (
    <Fragment>
        <span
          ref={ref}
          className="link--inverse"
          onClick={handleClick}
          onKeyUp={handleClick}
          onBlur={handleMouseOut}
          onFocus={handleMouseOver}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          role="button"
          tabIndex={-1}
        >
          {name}
          <Tooltip data={tooltipData} parent={ref.current} active={tooltipActive} />
        </span>
      <ChangeNameModal
        isOpen={isModalOpen}
        onRequestClose={handleRequestClose}
      />
    </Fragment>
  );
}

Name.displayName = 'Name';

const mapStateToProps = ({ myself: { character: { name } } }: IAppState) => ({ name });

export default connect(mapStateToProps)(Name);